/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Add_ItemInputs */

const en_task_flow_add_item = /** @type {(inputs: Task_Flow_Add_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add item`)
};

const pt_br2_task_flow_add_item = /** @type {(inputs: Task_Flow_Add_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar item`)
};

/**
* | output |
* | --- |
* | "Add item" |
*
* @param {Task_Flow_Add_ItemInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_add_item = /** @type {((inputs?: Task_Flow_Add_ItemInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Add_ItemInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_add_item(inputs)
	return pt_br2_task_flow_add_item(inputs)
});